import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectAccessToken, selectAdminRole } from '../../slices/staffSlice';
import { fetchRequests } from '../../Requests/getRequests';
import { show } from '../../slices/toastSlice';
import { authStaff } from '../../utils/constants';
import useConfigOptions from '../../hooks/useConfigOptions';
import { useNavigate } from 'react-router-dom';
import { Topbar, Sidebar, LoansTable, Loader, Filter } from "../../components";

function Index() {

    const { loanFilters } = useConfigOptions();
    const [loans, setLoans] = useState([]);
    const [loading, setLoading] = useState(false);
    const [metadata, setMetadata] = useState(null);

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const accessToken = useSelector(selectAccessToken);
    const adminRole = useSelector(selectAdminRole);
    const [isPagLoading, setIsPagLoading] = useState(false);
    const [pagLoans, setPagLoans] = useState(null);
    const [pagMetadata, setPagMetadata] = useState(null);
    const [filteredLoanType, setFilteredLoanType] = useState(null);

    let loadingInc = isPagLoading ? isPagLoading : loading;

    // create a function to handle pagination fetching
    const handlePagination = async(page) => {
        setIsPagLoading(true);

        let headers = authStaff(accessToken);
        let url = `/loans/staff/fetchLoans`;
        let params = { 
            loanType : filteredLoanType ? filteredLoanType : loanFilters[0].value, 
            adminRole : adminRole,
            page : page || 1 
        };

        let res = await fetchRequests(url, "GET", headers, params, {});
        setIsPagLoading(false);

        if(res?.code === 401){
            // clear local storage and redirect to login
            sessionStorage.clear();
            navigate("/login");
            dispatch(show({
                type : "error",
                state : true,
                message : "Your session has expired. Please login to continue."
            }))
            return;
        }

        if(res?.err){
            dispatch(show({
                type : "error",
                state : true,
                message : res?.err
            }))
            return;
        }

        // set the loans and metadata to the paginated loans and metadata
        setPagLoans(res.loans);
        setPagMetadata(res.metadata);
    }

    useEffect(() => {
        document.title = `Loan Applications - ${process.env.REACT_APP_SITE_NAME}`;
    },[])

    return (
        <div className='main-container'>
            <Topbar />
            <Sidebar />

            <main className='main-content'>

                <section className='section-container'>
                    
                    <div className='flex items-center justify-between mb-6'>
                        <div>
                            <h1 className='text-2xl font-semibold text-gray-900 dark:text-gray-50 flex items-center gap-2'>
                                Loan Applications
                                {loadingInc && <Loader color={"text-gray-400"} size={"w-4 h-4"} />}
                            </h1>
                            <p className='text-sm text-gray-500 dark:text-gray-400 mt-0.5'>Applications currently in the review pipeline.</p>
                        </div>

                        <Filter
                            endpoint="fetchLoans"
                            state="initial"
                            setLoading={setLoading}
                            setLoans={setLoans}
                            setMetadata={setMetadata}
                            setFilteredLoanType={setFilteredLoanType}
                        />
                    </div>

                    <LoansTable 
                        loans={pagLoans ? pagLoans : loans} 
                        metadata={pagMetadata ? pagMetadata : metadata}
                        handlePagination={handlePagination}
                    />

                </section>

            </main>

        </div>
    )
}

export default Index